webpackJsonp([16],{

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  LIFTIGNITER_INVENTORY_FIELD: ['url', 'id', 'description', 'social_head', 'published_time', 'authors', 'title', 'topics', 'section']
};

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(39);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _liftigniter = __webpack_require__(1331);

var _liftigniter2 = _interopRequireDefault(_liftigniter);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isFunction = __webpack_require__(84);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    jsKey: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.jsKey && !(0, _get2.default)(window, '$p', false)) {
      (function (w, d, s, p, v, e, r) {
        w.$ps = w.performance && w.performance.now && typeof w.performance.now === 'function' ? w.performance.now() : undefined;
        w.$igniter_var = v;
        w[v] = w[v] || function () {
          (w[v].q = w[v].q || []).push(arguments);
        };
        w[v].l = 1 * new Date();
        e = d.createElement(s), r = d.getElementsByTagName(s)[0];
        e.async = 1;
        e.src = p + '?ts=' + (+new Date() / 3600000 | 0);
        r.parentNode.insertBefore(e, r);
      })(window, document, 'script', '//cdn.petametrics.com/' + this.jsKey + '.js', '$p');

      this.setIsLiftigniterInit(true);

      var customConfig = {
        inventory: {
          collect: false,
          version: undefined
        },
        sdk: {
          requestFields: (0, _get2.default)(_liftigniter2.default, 'LIFTIGNITER_INVENTORY_FIELD', []),
          multiFetch: true
        }
      };
      $p('init', this.jsKey, { config: customConfig });
      _eventBus2.default.$on('liftigniter-ResetPageview', function () {
        _this.resetPageview();
      });
      _eventBus2.default.$on('liftigniter-SendPageView', function () {
        _this.sendPageView();
      });
      _eventBus2.default.$on('liftigniter-FetchInventory', function (max, opts, resolve) {
        if ((0, _isFunction2.default)(resolve)) {
          _this.isReady().then(function () {
            _this.fetchInventory(max, opts, resolve);
          }).catch(function () {
            resolve([]);
          });
        }
      });
    }
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setIsLiftigniterInit']), {
    isReady: function isReady() {
      return new _promise2.default(function (resolve, reject) {
        if (typeof window !== 'undefined' && (0, _isFunction2.default)($p)) resolve();
        reject(new Error('Liftigniter does not inited yet.'));
      });
    },
    resetPageview: function resetPageview() {
      this.isReady().then(function () {
        $p('resetPageview');
      }).catch(function (e) {
        console.log(e);
      });
    },
    sendPageView: function sendPageView() {
      this.isReady().then(function () {
        $p('send', 'pageview');
      }).catch(function (e) {
        console.log(e);
      });
    },

    fetchInventory: function fetchInventory() {
      var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var resolve = arguments[2];

      $p('register', {
        max: max,
        opts: opts,
        widget: '',
        callback: function callback(resp) {
          resolve((0, _map2.default)((0, _get2.default)(resp, 'items', []), 'id'));
        }
      });
      $p('fetch');
    }
  }),
  render: function render(h) {
    return h;
  }
};

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1360),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 16.a23bce3ef4e8ada9d846.js